<template>
  <div class="college-base-settings">
    <a-card title="系统基本信息设置">
      <a-row :gutter="16">
        <a-col :md="24" :lg="16">
          <a-form layout="vertical" :form="form">
            <a-form-item label="系统图标">
              <a-upload
                name="file"
                :action="action"
                :headers="headers"
                :showUploadList="false"
                @change="uploadCallback"
              >
                <div class="ant-upload-preview">
                  <a-icon type="cloud-upload-o" class="upload-icon" />
                  <div class="mask">
                    <a-icon type="plus" />
                  </div>
                  <img
                    :src="college.badge || '@/assets/images/default-avatar.png'"
                    style="width: 120px;height: 120px"
                  />
                </div>
              </a-upload>
            </a-form-item>
            <a-form-item label="组织机构名称">
              <a-input
                placeholder="高校名"
                v-decorator="['name', {
                  initialValue: college.name,
                  rules: [
                    {
                      required: true,
                      message: '请输入高校名'
                    },
                    {
                      max: 20,
                      message: '最多输入20个字'
                    }
                  ]
                }]"
              />
            </a-form-item>
            <a-form-item label="机构简介">
              <a-textarea
                placeholder="机构简介"
                v-decorator="['brief', { initialValue: college.brief }]"
                :autosize="{ minRows: 4, maxRows: 4 }"
              />
            </a-form-item>

            <a-form-item label="高校标识符（将作为系统通知邮件的邮箱地址前缀）">
              <a-input
                placeholder="系统通知邮箱前缀为非汉字字符"
                v-decorator="['identifier', {
                  initialValue: college.identifier,
                  rules: [{
                    required: true,
                    message: '请输入高校标识符'
                  },]
                }]"
              />
            </a-form-item>

            <a-form-item label="所在地">
              <a-cascader
                :options="areaOptions"
                placeholder="所在地"
                v-decorator="['location', { initialValue: college.location }]"
              ></a-cascader>
            </a-form-item>
            <a-form-item label="街道地址">
              <a-input
                placeholder="街道地址"
                v-decorator="['streetAddress', { initialValue: college.streetAddress }]"
              ></a-input>
            </a-form-item>
            <a-form-item>
              <a-button type="primary" @click="handleSubmit">保存</a-button>
            </a-form-item>
          </a-form>
        </a-col>
      </a-row>
    </a-card>
    <avatar-modal ref="modal"></avatar-modal>
  </div>
</template>

<script>
import $axios from '@/utils/axios'
import { Colleges } from '@/resources'
import { areaOptions } from '@/utils/constants/area'
import { mapState, mapActions } from 'vuex'
import AvatarModal from './AvatarModal'

export default {
  components: {
    AvatarModal
  },
  data () {
    return {
      college: { },
      form: this.$form.createForm(this),
      preview: {},
      option: {
        img: '@/assets/images/default-avatar.png',
        info: true,
        size: 1,
        outputType: 'jpeg',
        canScale: false,
        autoCrop: true,
        // 只有自动截图开启 宽度高度才生效
        autoCropWidth: 180,
        autoCropHeight: 180,
        fixedBox: true,
        // 开启宽度和高度比例
        fixed: true,
        fixedNumber: [1, 1]
      },
      areaOptions
    }
  },
  computed: {
    ...mapState({ basicInfo: state => state.user.basicInfo }),
    action () {
      return `${$axios.defaults.baseURL}/uploads`
    },
    headers () {
      const vm = this
      return {
        'X-Token': vm.$ls.get('X-Token')
      }
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    ...mapActions(['SetBasicInfo']),
    async fetchData () {
      const data = await Colleges.find()
      this.college = data.college
    },
    async handleSubmit () {
      await this.form.validateFields(async (err, values) => {
        if (!err) {
          const data = { ...values, badge: this.college.badge }
          const { college } = await Colleges.update({ college: data })
          this.college = college
          const collegeInfo = Object.assign(
            { ...this.basicInfo },
            { college: { badge: college.badge, name: college.name } }
          )
          this.SetBasicInfo(collegeInfo)
          this.$message.success('内容已保存。')
        }
      })
    },
    uploadCallback ({ file }) {
      const vm = this
      if (file.status === 'done') {
        vm.$set(vm.college, 'badge', file.response.url)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.avatar-upload-wrapper {
  height: 200px;
  width: 100%;
}

.ant-upload-preview {
  position: relative;
  margin: 0 auto;
  width: 100%;
  max-width: 180px;
  border-radius: 50%;
  box-shadow: 0 0 4px #ccc;

  .upload-icon {
    position: absolute;
    top: 0;
    right: 10px;
    font-size: 1.4rem;
    padding: 0.5rem;
    background: rgba(222, 221, 221, 0.7);
    border-radius: 50%;
    border: 1px solid rgba(0, 0, 0, 0.2);
  }
  .mask {
    opacity: 0;
    position: absolute;
    background: rgba(0, 0, 0, 0.4);
    cursor: pointer;
    transition: opacity 0.4s;

    &:hover {
      opacity: 1;
    }

    i {
      font-size: 2rem;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -1rem;
      margin-top: -1rem;
      color: #d6d6d6;
    }
  }

  img,
  .mask {
    width: 100%;
    max-width: 180px;
    height: 100%;
    max-height: 180px;
    border-radius: 50%;
    overflow: hidden;
  }
}
</style>
